import Checked from '../assets/images/checked.svg'

export type PlanProps = {
  title: string
  recurrency: string
  subtitle: string
  price: string
  items: string[]
  url: string
  openModal?: (e: any) => void
  recomended?: boolean
}

export default function CardPlan({
  title,
  subtitle,
  price,
  items,
  url,
  openModal,
  recomended,
  recurrency
}: PlanProps) {
  return (
    <article className={recomended ? 'recomended' : ''}>
      {recomended ? (
        <div className="black-november">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 9H9.01M15 15H15.01M16 8L8 16M7.33377 3.8187C8.1376 3.75455 8.90071 3.43846 9.51447 2.91542C10.9467 1.69486 13.0533 1.69486 14.4855 2.91542C15.0993 3.43846 15.8624 3.75455 16.6662 3.8187C18.5421 3.96839 20.0316 5.45794 20.1813 7.33377C20.2455 8.1376 20.5615 8.90071 21.0846 9.51447C22.3051 10.9467 22.3051 13.0533 21.0846 14.4855C20.5615 15.0993 20.2455 15.8624 20.1813 16.6662C20.0316 18.5421 18.5421 20.0316 16.6662 20.1813C15.8624 20.2455 15.0993 20.5615 14.4855 21.0846C13.0533 22.3051 10.9467 22.3051 9.51447 21.0846C8.90071 20.5615 8.1376 20.2455 7.33377 20.1813C5.45794 20.0316 3.96839 18.5421 3.8187 16.6662C3.75455 15.8624 3.43846 15.0993 2.91542 14.4855C1.69486 13.0533 1.69486 10.9467 2.91542 9.51447C3.43846 8.90071 3.75455 8.1376 3.8187 7.33377C3.96839 5.45794 5.45794 3.96839 7.33377 3.8187ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9ZM15.5 15C15.5 15.2761 15.2761 15.5 15 15.5C14.7239 15.5 14.5 15.2761 14.5 15C14.5 14.7239 14.7239 14.5 15 14.5C15.2761 14.5 15.5 14.7239 15.5 15Z"
              stroke="url(#paint0_linear_8_1662)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_8_1662"
                x1="12"
                y1="2"
                x2="12"
                y2="22"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FFD500" />
                <stop offset="1" stopColor="#C27A08" />
              </linearGradient>
            </defs>
          </svg>
          <p>Black November</p>
        </div>
      ) : null}
      <header>
        <h1>
          {title} {recomended ? <span>Recomendado</span> : null}
        </h1>
        <p dangerouslySetInnerHTML={{ __html: subtitle }} />
        <div>
          <p className="price">
            R$ {price} <small>/Mês</small>
          </p>
        </div>
        <div className="divider" />
        <div className="items">
          {items.map((item, index) => (
            <div key={index}>
              <img src={Checked} alt={item} />{' '}
              <p dangerouslySetInnerHTML={{ __html: item }} />
            </div>
          ))}
        </div>
      </header>
      <a
        href={url}
        target="_blank"
        onClick={openModal}
        title={`Quero o ${title}`}
        className="btn btn-primary"
        rel="noreferrer"
        onClickCapture={() => {
          window.fbq('track', 'InitiateCheckout', {
            value: Number(price.replace(',', '.')),
            currency: 'BRL',
            content_name: `${title} - ${subtitle}`,
            content_category: 'subscription',
            num_items: 1
          })
        }}
      >
        Quero o plano {recurrency}
      </a>
    </article>
  )
}
